export default __webpack_public_path__ + "assets/ico_why_della8_stars-cfe43911.svg";